import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { getStatusTranslation } from "../utils/getStatusTranslation";
export var usePublisherTable = function (onRowClick) {
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var handleNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.publisher.table.columns.name",
            }),
            key: "name",
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher.table.columns.nameSuffix",
            }),
            key: "nameSuffix",
            cellRenderer: function (item) { return (item === null || item === void 0 ? void 0 : item.nameSuffix) || ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher.table.columns.qualifier",
            }),
            key: "qualifier",
            cellRenderer: function (item) { return (item === null || item === void 0 ? void 0 : item.qualifier) || ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.publisher.table.columns.status",
            }),
            key: "status",
            cellRenderer: function (item) { return getStatusTranslation(intl, item.status); },
        },
    ]; }, [formatMessage, handleNameClick, intl]);
    return {
        columns: columns,
    };
};
